export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()
    const counterId = config.public.yandexMetrikaId
  
    if (!counterId) {
      console.warn('Яндекс.Метрика: ID счётчика не задан')
      return
    }
  
    useHead({
      script: [
        {
          innerHTML: `
            (function(m,e,t,r,i,k,a){
                m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                m[i].l=1*new Date();
                for (var j = 0; j < document.scripts.length; j++) {
                  if (document.scripts[j].src === r) { return; }
                }
                k=e.createElement(t),a=e.getElementsByTagName(t)[0],
                k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
            })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
  
            ym(${counterId}, "init", {
                webvisor:true,
                trackHash:true,
                clickmap:true,
                trackLinks:true,
                accurateTrackBounce:true
            });
          `,
          type: 'text/javascript',
        },
      ],
      noscript: [
        {
          children: `<div><img src="https://mc.yandex.ru/watch/${counterId}" style="position:absolute; left:-9999px;" alt="" /></div>`,
        },
      ],
    })
  
    // hit на каждый переход
    const nuxtApp = useNuxtApp()
    nuxtApp.hook('page:finish', () => {
      ;(window as any).ym?.(counterId, 'hit', window.location.pathname + window.location.search)
    })
  })